/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
function setmyloc(){
    (function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined'
        && typeof require === 'function' ? factory(require('../moment')) :
            typeof define === 'function' && define.amd ? define(['../moment'], factory) :
                factory(global.moment)
    }(this, (function (moment) { 'use strict';


        var units = {
            'ss' : 'sekundė_sekundžių_sekundes',
            'm' : 'minutė_minutės_minutę',
            'mm': 'minutės_minučių_minutes',
            'h' : 'valanda_valandos_valandą',
            'hh': 'valandos_valandų_valandas',
            'd' : 'diena_dienos_dieną',
            'dd': 'dienos_dienų_dienas',
            'M' : 'mėnuo_mėnesio_mėnesį',
            'MM': 'mėnesiai_mėnesių_mėnesius',
            'y' : 'metai_metų_metus',
            'yy': 'metai_metų_metus'
        };
        function translateSeconds(number, withoutSuffix, key, isFuture) {
            if (withoutSuffix) {
                return 'kelios sekundės';
            } else {
                return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
            }
        }
        function translateSingular(number, withoutSuffix, key, isFuture) {
            return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
        }
        function special(number) {
            return number % 10 === 0 || (number > 10 && number < 20);
        }
        function forms(key) {
            return units[key].split('_');
        }
        function translate(number, withoutSuffix, key, isFuture) {
            var result = number + ' ';
            if (number === 1) {
                return result + translateSingular(number, withoutSuffix, key[0], isFuture);
            } else if (withoutSuffix) {
                return result + (special(number) ? forms(key)[1] : forms(key)[0]);
            } else {
                if (isFuture) {
                    return result + forms(key)[1];
                } else {
                    return result + (special(number) ? forms(key)[1] : forms(key)[2]);
                }
            }
        }
        var lt = moment.defineLocale('lt', {
            months : {
                format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
                standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
                isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
            },
            monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
            weekdays : {
                format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
                standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
                isFormat: /dddd HH:mm/
            },
            weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
            weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
            weekdaysParseExact : true,
            longDateFormat : {
                LT : 'HH:mm',
                LTS : 'HH:mm:ss',
                L : 'YYYY-MM-DD',
                LL : 'YYYY [m.] MMMM D [d.]',
                LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
                l : 'YYYY-MM-DD',
                ll : 'YYYY [m.] MMMM D [d.]',
                lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
                llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
            },
            calendar : {
                sameDay : '[Šiandien] LT',
                nextDay : '[Rytoj] LT',
                nextWeek : 'dddd LT',
                lastDay : '[Vakar] LT',
                lastWeek : '[Praėjusį] dddd LT',
                sameElse : 'L'
            },
            relativeTime : {
                future : 'po %s',
                past : 'prieš %s',
                s : translateSeconds,
                ss : translate,
                m : translateSingular,
                mm : translate,
                h : translateSingular,
                hh : translate,
                d : translateSingular,
                dd : translate,
                M : translateSingular,
                MM : translate,
                y : translateSingular,
                yy : translate
            },
            dayOfMonthOrdinalParse: /\d{1,2}-oji/,
            ordinal : function (number) {
                return number + '-oji';
            },
            week : {
                dow : 1, // Monday is the first day of the week.
                doy : 4  // The week that contains Jan 4th is the first week of the year.
            }
        });



        return lt;

    })));
}
(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                setmyloc();
                var now = new Date();
                var start = new Date(new Date().setYear(now.getFullYear()-100));
                var end = new Date(new Date().setYear(now.getFullYear()-0));


                jQuery('#user_birth_date').attr('placeholder', 'YYYY-mm-dd').attr('autocomplete', 'off');
                jQuery('#user_birth_date').datetimepicker({
                    minDate : start,
                    maxDate   : end,
                    format: 'YYYY-MM-DD',
                    viewMode: 'years',

                    locale: moment.locale('lt')
                });
                jQuery('#user_birth_date').val('');


                $('[name="mano_agata"]').attr('required', 'true');
              //  $('[name="user_works[]"]').attr('required', 'true');
                $('[name="mano_agata"]:first').attr('checked', 'true');


             //   $("input.user_works[type='checkbox']").on('ifChecked', function(e) {
             //       $(e.target).trigger('change');
             //   });

            //   $("input.user_works[type='checkbox']").on('ifUnchecked', function(e) {
             //       $(e.target).trigger('change');
            //    });

           //     $("input.user_works[type='checkbox']").on('change', function () {
            //        if($("input.user_works[type='checkbox']:checked").length > 0 ){
              //          $("input.user_works[type='checkbox']").removeAttr('required');
             //       } else {
             //           $("input.user_works[type='checkbox']").attr('required', 'true');

               //     }
          //      })


                try {
                    $(window).load(function(){
                        if($('.atlikejams-slider').length > 0){
                            $('.atlikejams-slider').fadeIn(1000).removeClass('hidden');
                        }

                    });
                } catch (e) {

                }



                // JavaScript to be fired on all pages
                var $w = $(window).width();
                if($w<1024) {
                    $('.page-template-page-tarifai').find('table').wrap("<div class='table-responsive '></div>");
                }
                $.fn.extend({

                    elipsize: function (lh) {

                        this.each(function () {
                            var elipsized = false;
                            var $this = jQuery(this);
                            if (typeof $this.data().fullHTML === 'undefined') {

                                $this.data({fullHTML: this.innerHTML});
                            }
                            this.innerHTML = $this.data().fullHTML;
                            var wordArray = $this.data().fullHTML.split(' ');

                            var lineHeight = parseInt($this.css('line-height')) * lh;

                            while ($this.innerHeight() > lineHeight) { // 5px paklaida
                                wordArray.pop();
                                this.innerHTML = wordArray.join(' ') + '...';
                                if (wordArray.length <= 1) {
                                    break;
                                }
                                elipsized = true;

                            }
                            $this.attr("data-elipsized", elipsized);
                        });
                        return this;
                    }

                });


                function KLIP_ellipsis_func() {

                    var $windowWidth = $(window).innerWidth();
                    if ( $windowWidth > 1024 && $windowWidth <  1399) {

                        var $element = $('.techno-item-name');
                        $element.elipsize(2);
                        var $element2 = $('.techno-item-description');
                        $element2.elipsize(6);
                    }
                    if ($windowWidth < 1024) {

                        var $element = $('.techno-item-name');
                        $element.elipsize(2);
                        var $element2 = $('.techno-item-description');
                        $element2.elipsize(2);
                    }

                }
                KLIP_ellipsis_func();


                $('.form-page p').each(function() {
                    var $this = $(this);
                    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
                        $this.remove();
                });

                var $w = $(window).width();
                if($w<1024){
                    var $img = $('img.alignnone.size-full');
                    $img.hide();
                    var $src = $img.attr('src');
                    $img.after( "<a href='"+$src+"'  class='magnific checkphoto'>ŽIŪRĖTI NUOTRAUKĄ</a>" );

                }

                $('.mobile-button').on('click', function () {
                    var $this = $(this);
                    if ($this.hasClass('active')) {
                        $this.removeClass('active');

                    } else {
                        $this.addClass('active');
                    }
                    $('body').toggleClass('modal-open');
                    $('.hmobile').slideToggle('fast');
                });

                var windowsize = $(window).width();
                if (windowsize > 1024) {
                    $("a.menu__item").hover(function () {

                        $(this).siblings().find('.hbo-item').addClass("f28");
                    }, function () {

                        $(this).siblings().find('.hbo-item').removeClass("f28");
                    });
                }


                if ($('nav.menu').length > 0) {
                    'use strict';

                    var _createClass = function () {
                        function defineProperties(target, props) {
                            for (var i = 0; i < props.length; i++) {
                                var descriptor = props[i];
                                descriptor.enumerable = descriptor.enumerable || false;
                                descriptor.configurable = true;
                                if ("value" in descriptor) descriptor.writable = true;
                                Object.defineProperty(target, descriptor.key, descriptor);
                            }
                        }

                        return function (Constructor, protoProps, staticProps) {
                            if (protoProps) defineProperties(Constructor.prototype, protoProps);
                            if (staticProps) defineProperties(Constructor, staticProps);
                            return Constructor;
                        };
                    }();

                    function _classCallCheck(instance, Constructor) {
                        if (!(instance instanceof Constructor)) {
                            throw new TypeError("Cannot call a class as a function");
                        }
                    }

                    var Menu = function () {
                        function Menu(el) {
                            _classCallCheck(this, Menu);

                            this.DOM = {};
                            this.DOM.el = el;
                            this.DOM.items = Array.from(this.DOM.el.querySelectorAll('.menu__item'));
                            this.DOM.bgshape = document.querySelector('svg.scene > path');
                            this.initialShape = this.DOM.bgshape.getAttribute('d');
                            this.initEvents();
                        }

                        _createClass(Menu, [{
                            key: 'changeShape',
                            value: function changeShape(el) {
                                anime.remove(this.DOM.bgshape);
                                anime({
                                    targets: this.DOM.bgshape,
                                    duration: 1000,
                                    easing: 'easeOutQuad',
                                    d: el.dataset.shape
                                });
                            }
                        }, {
                            key: 'resetShape',
                            value: function resetShape() {
                                anime.remove(this.DOM.bgshape);
                                anime({
                                    targets: this.DOM.bgshape,
                                    duration: 1000,
                                    easing: 'easeOutQuint',
                                    d: this.initialShape
                                });
                            }
                        }, {
                            key: 'initEvents',
                            value: function initEvents() {
                                var _this = this;

                                this.mouseenterFn = function (ev) {
                                    return _this.mouseTimeout = setTimeout(function () {
                                        _this.isActive = true;
                                        _this.changeShape(ev.target);
                                        clearTimeout(_this.resetTimeout);
                                    }, 50);
                                };

                                this.mouseleaveFn = function () {
                                    clearTimeout(_this.mouseTimeout);
                                    if (!_this.isActive) return;
                                    _this.isActive = false;

                                    _this.resetTimeout = setTimeout(function () {
                                        _this.resetShape();
                                    }, 300);
                                };

                                this.DOM.items.forEach(function (item) {
                                    item.addEventListener('mouseenter', _this.mouseenterFn);
                                    item.addEventListener('mouseleave', _this.mouseleaveFn);
                                    item.addEventListener('touchstart', _this.mouseenterFn);
                                    item.addEventListener('touchend', _this.mouseleaveFn);
                                });
                            }
                        }]);

                        return Menu;
                    }();

                    ;

                    new Menu(document.querySelector('nav.menu'));
                }
                ;


                $('.form-page-a form').on('submit', function (e) {
                    $('.form-page-submit-error-22').addClass('hidden');
                    e.preventDefault();

                    if($('input.user_works').length > 0){
                        if(jQuery('input.user_works:checked').length==0) {
                            console.log('Please check at least one checkbox');
                            $('.form-page-submit-error-22').removeClass('hidden');
                            return false;
                        }
                    }


                    $.ajax({
                        type: "post",

                        url: ajaxurl,
                        data: {
                            action: 'ev_post_form',
                            data: $(".form-page-a form").serialize()
                        },
                        beforeSend: function () {
                            $('.form-page-submit-success').addClass('hidden');
                            $('.form-page-submit-error').addClass('hidden');
                            $('.form-send-server').html('<div class="spinner"><div class="spinner__item1"></div><div class="spinner__item2"></div><div class="spinner__item3"></div></div>');
                            $('.form-send-server').css({'pointer-events': 'none'});
                        },
                        success: function (json) {
                            $('.form-send-server').css({'pointer-events': 'all'});
                            $('.form-send-server').html('Siųsti');

                            if (json == 'true' || json == '"success"true' || json == '"success"1' || "success" || '"success"') {
                                $('.form-page-submit-success').removeClass('hidden')
                                $('#myform')[0].reset();
                            } else {
                                $('.form-page-submit-error').removeClass('hidden')
                            }

                            if(json == ''){
                                $('.form-page-submit-error').addClass('hidden')
                                $('.form-page-submit-error-error').removeClass('hidden')
                            }
                        },
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            $('.form-send-server').html('Siųsti');
                        }
                    });
                });


                $.each($('.form-page form div'), function (i, el) {
                    $(this).addClass('order-number-' + (i + 1));
                });
                $('.form-page form').css('opacity', 1);


                $('.sidebar-duk .duk-term ').on('click', function (e) {

                    if (!$(e.target).hasClass('duk-term-item')) {
                        $(this).find('.duk-term-wrap').slideToggle();
                        if($(this).hasClass('active')){
                            $(this).removeClass('active');
                        } else {
                            $(this).addClass('active');
                        }

                        $(this).siblings().removeClass('active');
                        $(this).siblings().find('.duk-term-wrap').slideUp();
                    }

                });

                $('.sidebar-duk .duk-term h3 a').on('click', function (e) {
                    e.preventDefault();

                });
                $('.page-template-page-forma2 select, .page-template-page-forma1 select').select2({
                    minimumResultsForSearch: -1
                });

                $('.search-button').on('click', function () {
                    $('.search-field-wrap').show();
                    $('input.search-field').focus();
                    $('.search-field').animate({width: 233});


                });


                $('[data-toggle="tooltip"]').tooltip();


                $(document).on('click', '.daugiau-item', function () {

                    $this = $(this);
                    $this.find('.daugiau-item-content').slideToggle('fast');
                    $this.siblings().find('.daugiau-item-content').slideUp('fast');
                    $this.siblings().removeClass('active');
                    if ($this.hasClass('active')) {
                        $this.removeClass('active');
                    } else {
                        $this.addClass('active');
                    }
                });


                $('.form-page input').iCheck({
                    checkboxClass: 'icheckbox_minimal',
                    radioClass: 'iradio_minimal',
                    increaseArea: '20%' // optional
                });

                $('.page-id-34 [data-term="0"]').hide();

                $(document).on('click', '#duk-select .dropdown-item', function () {
                    var val = $(this).data('term');
                    $(this).siblings().show();
                    $(this).hide();

                    var text = $(this).find('h3');
                    $('#duk-select').find('button.dropdown-toggle span').text(text.context.textContent);

                    if (val == 0) {
                        $('.duk-term').fadeIn(500)
                    } else {


                        $('.duk-term[data-term="' + val + '"]').fadeIn(500);
                        $('.duk-term[data-term="' + val + '"]').siblings().not('.duk-main').hide();

                    }
                });


                /*

                                $(".content-editor table").wrap("<div class='table table-responsive' />");
                */
                /*
                //menu
                $('.hamburger').on('click', function () {
                    $(this).toggleClass('is-active');
                });
                */

                //fix footer
                function fixfooter() {
                    $('#page-wrapper').css('padding-bottom', $('footer').innerHeight());
                }

                fixfooter();
                var wWidth = $(window).width();
                $(window).resize(function () {
                    if ($(window).width() === wWidth) {
                        return;
                    }
                    wWidth = $(window).width();
                    fixfooter();
                });


                $('a.disabled').on('click', function (e) {
                    e.preventDefault();
                });


                //AOS

                AOS.init();


                /*
                                //ajax get references
                                $('.references-archive.arch .references-view-more-wrap').on('click', function () {
                                    var page = $('.references-view-more').data('page');
                                    $.ajax({
                                        type: "post",

                                        url: ajaxurl,
                                        data: {
                                            action: 'ev_get_references',
                                            page: page
                                        },
                                        beforeSend: function () {
                                            $('.loader').show();
                                        },
                                        success: function (msg) {
                                            $('.loader').hide();
                                            var data = JSON.parse(msg);
                                            $('.references-archive ul').append(data.items);
                                            $('.references-view-more').data('page', page + 1);
                                            if (data.message === 'end') {
                                                $('.references-view-more-wrap').hide();
                                            }
                                        }
                                    });
                                });
                */


//lightbox

                $('.magnific').magnificPopup({
                    type: 'image',
                    gallery: {enabled: true}
                    // other options
                });

                $('.slider-for').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    cssEase: 'linear',
                    speed: 600,
                    asNavFor: '.slider-nav',
                    infinite:false,
                    swipe:false,
                    draggable: false
                });
                $('.slider-nav').slick({
                    slidesToShow: 2,
                    slidesToScroll:0,
                    asNavFor: '.slider-for',
                    infinite:false,
                    centerMode: true,
                    focusOnSelect: true
                });


            },
            finalize: function () {

                function GetRequestParam(param) {
                    var res = null;
                    try {
                        var qs = decodeURIComponent(window.location.search.substring(1));//get everything after then '?' in URI
                        var ar = qs.split('&');
                        $.each(ar, function (a, b) {
                            var kv = b.split('=');
                            if (param === kv[0]) {
                                res = kv[1];
                                return false;//break loop
                            }
                        });
                    } catch (e) {
                    }
                    return res;
                }

                if (GetRequestParam('type')) {
                    if (GetRequestParam('type') == 'press') {
                        $('.media-selector a[data-media="press"]').trigger('click');
                        $('.menunews').removeClass('act');
                        $('.menupress').addClass('act');

                    } else if (GetRequestParam('type') == 'news') {
                        $('.media-selector a[data-media="news"]').trigger('click');
                        $('.menunews').addClass('act');
                        $('.menupress').removeClass('act');
                    }
                }

            }
        },
        // Home page
        'home': {
            init: function () {


            },
            finalize: function () {

            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


